import { useScrollReveal } from '../../hooks/useScrollReveal';
import { useState } from 'react';

interface AnimatedImageProps {
  src: string;
  alt: string;
  className?: string;
}

export default function AnimatedImage({ src, alt, className = '' }: AnimatedImageProps) {
  const { ref, isVisible } = useScrollReveal();
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      ref={ref}
      className={`overflow-hidden ${className}`}
    >
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover transition-all duration-500 ease-out ${
          isVisible && loaded
            ? 'opacity-100 scale-100'
            : 'opacity-0 scale-[1.02]'
        }`}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
}
